import React from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const phoneNumber = "9561613355";
  const message = "Hello! I'm interested in your flower event services.";
  
  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <button className="whatsapp-float" onClick={handleWhatsAppClick}>
      <i className="fab fa-whatsapp"></i>
      <span className="whatsapp-tooltip">Chat with us!</span>
    </button>
  );
};

export default WhatsAppButton;